export default __webpack_public_path__ + "static/media/4.c35d7414.jpg";